module.exports = __webpack_public_path__ + "static/media/icon_play.b82a2915.svg";